import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Input from './Input';

const FlexForm = styled.form`
  flex: 1;
`;

export default class SearchForm extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    onFormSubmit: PropTypes.func,
  };

  static defaultProps = {
    placeholder: 'Search...',
  };

  state = {
    value: '',
  };

  handleChange = e => {
    this.setState({ value: e.target.value });
  };

  handleClear = () => {
    this.setState({ value: '' });
  };

  handleSubmit = e => {
    e.preventDefault();
    return this.props.onFormSubmit(this.state.value);
  };

  render() {
    return (
      <FlexForm action="." onSubmit={this.handleSubmit}>
        <Input
          onChange={this.handleChange}
          onClear={this.handleClear}
          value={this.state.value}
          {...this.props}
        />
      </FlexForm>
    );
  }
}
